import { useEffect } from 'react'
import { useTransaction } from '@web/walter-lib/stream'
import { useNotification } from '@web/walter-ui-kit'
import { processData } from './processData'
import { useIgnoreTxNotificationsStore } from '~store/ignoreTxNotifications'

export const useTxNotifications = () => {
    const ignoredState = useIgnoreTxNotificationsStore()
    const { push } = useNotification()
    const { data } = useTransaction()

    // eslint-disable-next-line complexity
    useEffect(() => {
        if (data) {
            //handle swap and otc transactions
            if (['SWAP', 'OTC'].includes(data?.type || '')) {
                const swapTransactionId = data?.meta?.instant_exchange?.id || data?.meta?.id || data?.id

                if (swapTransactionId && ignoredState.ids.has(String(swapTransactionId))) {
                    return
                }
            }

            if (data.native?.tx_id && ignoredState.ids.has(data.native.tx_id)) {
                return
            }

            const notification = processData(data)
            notification && push(notification)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])
}
